import axios from "axios";
import { Constants } from "../Constants";

const instance = axios.create({ baseURL: Constants.BASE_URL });

export const imageUpload = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
        "content-type": "multipart/form-data",
      },
    };
    return await instance.post(
      `members/image_upload?type=${data.type}`,
      data.form,
      httpOptions
    );
  } catch (error) {
    throw error;
  }
};

export const fetchMembers = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.get(`/members`, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const postMember = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.post(`/members`, data, httpOptions);
  } catch (error) {
    throw error;
  }
};

export const deleteMember = async (data: any) => {
  try {
    const httpOptions = {
      headers: {
        Authorization: data.token,
      },
    };
    return await instance.delete(`/members/${data.id}`, httpOptions);
  } catch (error) {
    throw error;
  }
};
